import { formatNumberWithCommas } from "@/utils";
import { AvatarIcon } from "@roman/shared/components/Icons/AvatarIcon";
import type { MarketRankEnded, MarketRankLive } from "@roman/shared/types/PredictionMarket";
import { cn, getColorStyleByRank } from "@roman/shared/utils";

export const RankingRow = ({
  participantChoiceRank,
  avatarSize = "w-[36px] h-[36px]",
}: {
  participantChoiceRank: MarketRankLive["ranks"][number] | MarketRankEnded["ranks"][number];
  avatarSize?: string;
}) => {
  const isEnded = "prizes" in participantChoiceRank;

  return (
    <div className="flex items-center border-b border-light-gray h-[60px]">
      <div className="flex items-center justify-between w-full">
        <div className="w-5 text-center">
          <p className={cn("text-center text-2xl", getColorStyleByRank(participantChoiceRank.rank))}>
            {participantChoiceRank.rank}
          </p>
        </div>

        {/* User Info */}
        <div className="flex items-center gap-2 flex-1 pl-2">
          {participantChoiceRank.userPhotoUrl ? (
            <div className={`rounded-full ${avatarSize} bg-secondary`}>
              <img
                src={participantChoiceRank.userPhotoUrl || "/assets/player-shirt.png"}
                alt={participantChoiceRank.userName.substring(0, 1)}
                className="rounded-full w-full h-full object-cover"
                referrerPolicy="no-referrer"
              />
            </div>
          ) : (
            <div className={`rounded-full bg-secondary flex justify-center items-center ${avatarSize}`}>
              <AvatarIcon />
            </div>
          )}
          <p className="text-[14px] font-medium leading-normal tracking[-0.14px] text-black">
            {participantChoiceRank.userName}
          </p>
        </div>

        {/* Total Points */}
        <div className="w-24 text-center">
          <span className="text-[14px] font-bold text-dark-gray">
            {formatNumberWithCommas(participantChoiceRank.freePointsEntered.toString())} pt
          </span>
        </div>

        {/* Expected Points */}
        <div className="w-24 text-center">
          <span className="text-[14px] font-bold text-green">
            {formatNumberWithCommas(
              isEnded ? participantChoiceRank.prizes.toString() : participantChoiceRank.potentialPrize.toString(),
            )}{" "}
            pt
          </span>
        </div>
      </div>
    </div>
  );
};
